import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-deepseek",
  "use": "icon-leo-deepseek-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-deepseek\">\r\n<g transform=\"translate(-176.128 -262.144) scale(1.344000)\">\r\n<path d=\"M192 512a320 320 0 0 1 640 0h-96a224 224 0 0 0-448 0H192z\" />\r\n  <path d=\"M320 576a192 192 0 0 1 384 0h-80a112 112 0 0 0-224 0h-80z\" />\r\n  <path d=\"M448 640a64 64 0 0 1 128 0H448z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-deepseek.svg
// module id = alkT
// module chunks = 396